module.exports = __webpack_public_path__ + "static/lonelyplanet.41465058.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/lonelyplanet.jpg
// module id = 850
// module chunks = 73261030922168